'use client'

import { useState } from 'react'
import { useTranslations } from 'next-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { Button } from '@teqplay/ui'

import ModalPortReporter from '../Modals/ModalPortReporter'

import './CardCTAPortReporter.scss'

function CardCTAPortReporter() {
  const t = useTranslations('VesselAlertCTA.prpCTA')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <>
      <div className="card-prp-cta">
        <div className="card-prp-cta-texts">
          <h3 className="">{t('title')}</h3>
          <p>{t('message')}</p>
        </div>
        <div className="card-prp-cta-actions">
          <Button variant="brand-primary" onClick={() => setIsModalOpen(true)}>
            {t('button')}
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        </div>
      </div>

      <ModalPortReporter isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}

export default CardCTAPortReporter
